import React from "react";
import { Box, Typography } from "@mui/material";
import { colors } from "./colors";
import { motion } from "framer-motion";
const MotionTypography = motion(Typography);

function HeroAurora() {
  return (
    <Box
      aria-hidden
      sx={{
        position: "absolute",
        inset: 0,
        overflow: "hidden",
        zIndex: 0,
        "@keyframes auroradrift1": {
          "0%": { transform: "translate(0%, 0%) scale(1)" },
          "33%": { transform: "translate(6%, 10%) scale(1.1)" },
          "66%": { transform: "translate(-5%, 6%) scale(0.93)" },
          "100%": { transform: "translate(0%, 0%) scale(1)" },
        },
        "@keyframes auroradrift2": {
          "0%": { transform: "translate(0%, 0%) scale(1)" },
          "40%": { transform: "translate(-8%, -6%) scale(1.08)" },
          "70%": { transform: "translate(5%, -10%) scale(0.96)" },
          "100%": { transform: "translate(0%, 0%) scale(1)" },
        },
        "@keyframes auroradrift3": {
          "0%": { transform: "translate(0%, 0%) scale(1)" },
          "50%": { transform: "translate(10%, 5%) scale(1.06)" },
          "100%": { transform: "translate(0%, 0%) scale(1)" },
        },
      }}
    >
      {[
        {
          animation: "auroradrift1 22s ease-in-out infinite",
          background:
            "radial-gradient(ellipse at 85% 45%, rgba(232,163,61,0.1) 0%, transparent 60%), " +
            "radial-gradient(ellipse at 5% 70%, rgba(232,163,61,0.05) 0%, transparent 55%)",
          width: "140%",
          height: "320px",
          top: "-120px",
          left: "-20%",
          filter: "blur(48px)",
        },
        {
          animation: "auroradrift2 28s ease-in-out infinite",
          background:
            "radial-gradient(ellipse at 50% 100%, rgba(220,38,38,0.06) 0%, transparent 50%), " +
            "radial-gradient(ellipse at 60% 40%, rgba(246,197,111,0.08) 0%, transparent 60%)",
          width: "120%",
          height: "260px",
          top: "-80px",
          left: "-10%",
          filter: "blur(56px)",
        },
        {
          animation: "auroradrift3 34s ease-in-out infinite",
          background: "radial-gradient(ellipse at 50% 30%, rgba(255,216,154,0.06) 0%, transparent 55%)",
          width: "100%",
          height: "200px",
          top: "-50px",
          left: "0%",
          filter: "blur(60px)",
        },
      ].map((style, i) => (
        <Box key={i} sx={{ position: "absolute", ...style }} />
      ))}
    </Box>
  );
}

const effectsLayerSx = {
  position: "absolute",
  inset: 0,
  overflow: "hidden",
  zIndex: 0,
  pointerEvents: "none",
  userSelect: "none",
};

export default function DarkHeroPageEffects({ watermark }) {
  return (
    <Box aria-hidden sx={effectsLayerSx}>
      <HeroAurora />
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          opacity: 0.5,
          pointerEvents: "none",
          userSelect: "none",
          backgroundImage:
            "repeating-linear-gradient(0deg, transparent, transparent 3px, rgba(232,163,61,0.02) 3px, rgba(232,163,61,0.02) 4px)",
          "@keyframes scanMove": {
            from: { backgroundPosition: "0 0" },
            to: { backgroundPosition: "0 400px" },
          },
          animation: "scanMove 8s linear infinite",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
          userSelect: "none",
          backgroundImage: `
            linear-gradient(${colors.border.subtle} 1px, transparent 1px),
            linear-gradient(90deg, ${colors.border.subtle} 1px, transparent 1px)
          `,
          backgroundSize: "80px 80px",
          maskImage: "radial-gradient(ellipse 90% 70% at 50% 0%, black 0%, transparent 70%)",
        }}
      />
      {watermark ? (
        <MotionTypography
          initial={{
            opacity: 0,
            y: 80,
            scale: 1.08,
            filter: "blur(18px)",
            clipPath: "inset(100% 0% 0% 0%)",
          }}
          animate={{
            opacity: 1,
            y: 0,
            scale: 1,
            filter: "blur(0px)",
            clipPath: "inset(0% 0% 0% 0%)",
          }}
          transition={{
            duration: 1.6,
            delay: 0.9,
            ease: [0.22, 1, 0.36, 1],
          }}
          sx={{
            display: { xs: "none", md: "block" },
            position: "absolute",
            bottom: 0,
            left: { md: 10 },
            fontFamily: "'Inter', system-ui, sans-serif",
            fontSize: { md: "10rem", lg: "12rem", xl: "14rem" },
            fontWeight: 800,
            color: "rgba(255,255,255,0.02)",
            lineHeight: 1,
            letterSpacing: "-0.02em",
            textTransform: "uppercase",
            pointerEvents: "none",
            userSelect: "none",
            zIndex: 1,
            willChange: "transform, opacity, filter, clip-path",
          }}
        >
          {watermark}
        </MotionTypography>
      ) : null}
    </Box>
  );
}
